import { createContext, useContext, type ReactNode } from 'react';

/** Per-deployment settings, loaded at startup so one build can run anywhere. */
export interface OceanioConfig {
  apiBaseUrl: string;
  apiKey: string;
  tileUrl?: string;
}

const OceanioConfigContext = createContext<OceanioConfig | undefined>(
  undefined,
);

export const OceanioConfigProvider = ({
  config,
  children,
}: {
  config: OceanioConfig;
  children: ReactNode;
}) => (
  <OceanioConfigContext.Provider value={config}>
    {children}
  </OceanioConfigContext.Provider>
);

export const useOceanioConfig = () => {
  const config = useContext(OceanioConfigContext);
  if (!config) {
    throw new Error(
      'useOceanioConfig must be used within OceanioConfigProvider',
    );
  }
  return config;
};
